export default function (cli) {
  return {
    profile () {
      return cli.get(`${cli.apiEndpoint}accounts/profile/`)
    },
    dashboardSetting () {
      return cli.get(`${cli.apiEndpoint}accounts/profile/dashboard-setting/`)
    },
    setDashboardSetting (data) {
      return cli.patch(`${cli.apiEndpoint}accounts/profile/dashboard-setting/`).send({dashboardSetting: data})
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/accounts.js